import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import yn from 'yn'

import setPreCheckTime from '../../../../actions/setPreCheckTimeActions'

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_PRE_CHECK_IN)) {
	require('../../../../styles/css/components/confirmation/default/bk-flow-confirmation-precheck.css')
}
class BkFlowConfirmationPreCheckIn extends Component {

	constructor(props) {
		super(props)
		let defaultTime = 0

		Object.keys(props.preCheckTimeData).forEach(function(preCheckKey) {
			if( preCheckKey === props.reservationKey ) {
				return defaultTime = props.preCheckTimeData[preCheckKey]
			}
		})

		this.state = {
			preCheckinTime: defaultTime
		}
	}

	handleTimeChange( reservationKey, e ) {
		const { updatePreTimes } = this.props

		this.setState({ preCheckinTime: e.target.value })
		updatePreTimes(reservationKey, e.target.value)
	}

	render() {
		const { configData, reservationKey } = this.props

		const hotelLabels = configData.hotel.labels[0]

		let renderOptions = [],
		    availTimes = [],
				startTime = moment('16:00', 'HH:mm'),
				endTime = moment('24:00', 'HH:mm'),
				interval = moment('00:15', 'HH:mm').format('m')

		if (process.env.REACT_APP_COMPONENT_PRE_CHECK_IN_START) {
			startTime = moment(process.env.REACT_APP_COMPONENT_PRE_CHECK_IN_START, 'HH:mm')
		}

		if (process.env.REACT_APP_COMPONENT_PRE_CHECK_IN_INTERVAL) {
			interval = moment(process.env.REACT_APP_COMPONENT_PRE_CHECK_IN_INTERVAL, 'HH:mm').format('m')
		}

		// Construct time range based on property config start time
		while (startTime <= endTime) {
			availTimes.push(moment(startTime).format('HH:mm'))
			startTime = moment(startTime).add(interval, 'minutes')
		}

		for (let time in availTimes) {
			renderOptions.push(
				<option key={ availTimes[time] } value={ availTimes[time] }>{ moment(availTimes[time], 'HH:mm').format('hh:mm a') }</option>
			)
		}

		return (
			<div className="bk-flow-confirmation__pre-check-form">
				<select
					className='u-form-select'
					onChange={ e => this.handleTimeChange(reservationKey, e) }
					value={ this.state.preCheckinTime }
				>
					<option value="0" disabled>{ hotelLabels.selectTime }</option>
					{ renderOptions }
				</select>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		preCheckTimeData: state.preCheckTimeData,
	}
}

const mapDispatchToProps = dispatch => ({
	updatePreTimes(reservationKey, timeVal) {
		return dispatch(setPreCheckTime(reservationKey, timeVal))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowConfirmationPreCheckIn)


// WEBPACK FOOTER //
// ./src/components/confirmation/elements/default/BkFlowConfirmationPreCheckIn.js